import React from "react";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";
import { languages } from "../App";
import commericall from "../images/commericll2.jpg";
import gold from "../images/gold4.jpg";
import gold2 from "../images/gold3.jpg";
import importIm from "../images/import3.jpg";

const Commercial = () => {
  const { t } = useTranslation();
  const currentLangCode = cookies.get("i18next") || "en";
  const currentLang = languages.find((l) => l.code === currentLangCode);
  return (
    <div id="comm" className="tw-bg-gray-50">
      <div className=" tw-w-[85%] tw-mx-auto tw-py-20">
        <div className="tw-flex tw-items-center" data-aos="zoom-in-down">
          <span className="tw-h-[2px] tw-bg-one-gold tw-w-[40px] "></span>
          <span className=" tw-capitalize tw-text-3xl tw-font-bold tw-text-one-gold tw-p-5 sm:tw-p-3 tw-whitespace-nowrap sm:tw-text-2xl">
            {t("link2")}
          </span>
        </div>
        <div>
        <div  className="tw-p-3 tw-m-3" data-aos="zoom-in-down">
            <p className={` tw-border-third-gold tw-p-2 ${currentLangCode === "en" ? "tw-border-l-4 tw-pl-4" : "tw-border-r-4 tw-pr-4"} tw-text-gray-500 tw-text-lg md:tw-text-sm xs:tw-text-xs`}>
                {t("text_commercal")}
            </p>
         </div>
        </div>
        <div className=" tw-grid tw-gap-2 tw-grid-cols-4 md:tw-grid-cols-2 sm:tw-grid-cols-1 tw-mt-4" data-aos="fade-up">
          <div className="tw-rounded-lg tw-h-[300px] tw-overflow-hidden tw-relative tw-group">
            <div className="tw-absolute tw-top-0 tw-left-0 tw-bg-transparent-black tw-w-full tw-h-full tw-z-2"></div>
            <img
              src={commericall}
              className="tw-w-full tw-h-full tw-object-cover group-hover:tw-rotate-3 group-hover:tw-scale-[1.1] tw-duration-700"
              data-aos="zoom-in-down"
              data-aos-duration="2000"
            />
            <div
              className={`tw-absolute tw-bottom-8 ${
                currentLangCode === "en" ? "tw-left-3" : "tw-right-3"
              } tw-text-lg tw-z-3 tw-text-white tw-font-bold tw-tracking-wide`}
            >
              <span>{t("general_trade")}</span>
              <p className="tw-p-2">{t("locationOut")}</p>
            </div>
          </div>
          <div className="tw-rounded-lg tw-h-[300px] tw-overflow-hidden tw-relative tw-group">
            <div className="tw-absolute tw-top-0 tw-left-0 tw-bg-transparent-black tw-w-full tw-h-full tw-z-2"></div>
            <img
              src={gold}
              className="tw-w-full tw-h-full tw-object-cover group-hover:tw-rotate-3 group-hover:tw-scale-[1.1] tw-duration-700"
              data-aos="zoom-in-down"
              data-aos-duration="2000"
            />
            <div
              className={`tw-absolute tw-bottom-8 ${
                currentLangCode === "en" ? "tw-left-3" : "tw-right-3"
              } tw-text-lg tw-z-3 tw-text-white tw-font-bold tw-tracking-wide`}
            >
              <span>{t("trade_in_gold_bar")}</span>
              <p className="tw-p-2">
                {t("locationOut") + " - " + t("locationIn")}
              </p>
            </div>
          </div>
          <div className="tw-rounded-lg tw-h-[300px] tw-overflow-hidden tw-relative tw-group">
            <div className="tw-absolute tw-top-0 tw-left-0 tw-bg-transparent-black tw-w-full tw-h-full tw-z-2"></div>
            <img
              src={gold2}
              className="tw-w-full tw-h-full tw-object-cover group-hover:tw-rotate-3 group-hover:tw-scale-[1.1] tw-duration-700"
              data-aos="zoom-in-down"
              data-aos-duration="2000"
            />
            <div
              className={`tw-absolute tw-bottom-8 ${
                currentLangCode === "en" ? "tw-left-3" : "tw-right-3"
              } tw-text-lg tw-z-3 tw-text-white tw-font-bold tw-tracking-wide`}
            >
              <span>{t("trade_in_gold")}</span>
              <p className="tw-p-2">
                {t("locationOut") + " - " + t("locationIn")}
              </p>
            </div>
          </div>
          <div className="tw-rounded-lg tw-h-[300px] tw-overflow-hidden tw-relative tw-group">
            <div className="tw-absolute tw-top-0 tw-left-0 tw-bg-transparent-black tw-w-full tw-h-full tw-z-2"></div>
            <img
              src={importIm}
              className="tw-w-full tw-h-full tw-object-cover group-hover:tw-rotate-3 group-hover:tw-scale-[1.1] tw-duration-700"
              data-aos="zoom-in-down"
              data-aos-duration="2000"
            />
            <div
              className={`tw-absolute tw-bottom-8 ${
                currentLangCode === "en" ? "tw-left-3" : "tw-right-3"
              } tw-text-lg tw-z-3 tw-text-white tw-font-bold tw-tracking-wide`}
            >
              <span>{t("import_and_export")}</span>
              <p className="tw-p-2">{t("locationIn")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Commercial;
